import React, { useMemo } from 'react';

import clsx from 'clsx';
import { TooltipPlacement } from 'antd/lib/tooltip';

import { Icon, IconType } from '@atoms';
import { Tooltip, TooltipProps } from '@molecules/tooltip';

import { colors } from '@styles';

import classes from './tooltip-with-icon.module.scss';

type Props = {
  iconColor?: keyof typeof colors;
  iconSize?: number;
  className?: string;
  tooltipPlacement?: TooltipPlacement;
  innerClassName?: string;
  icon?: IconType;
} & TooltipProps;

export const TooltipWithIcon = ({
  className,
  iconColor = 'slate_gray',
  iconSize = 22,
  tooltipPlacement = 'rightTop',
  children,
  innerClassName,
  icon = 'info',
  ...tooltipProps
}: Props) => {
  const iconComponent = useMemo(
    () => (
      <Icon
        icon={icon}
        className={classes.icon}
        style={{ color: colors[iconColor].hex(), fontSize: iconSize }}
      />
    ),
    [iconColor, iconSize],
  );

  return (
    <span className={clsx(classes.wrapper, className)}>
      {/* TOOLTIP */}
      <Tooltip
        placement={tooltipPlacement}
        type="dark"
        size="big"
        {...tooltipProps}
      >
        {/* CHILD */}
        {children && (
          <div className={clsx(classes.inner, innerClassName)}>
            {children}
            {iconComponent}
          </div>
        )}

        {/* ICON */}
        {!children && iconComponent}
      </Tooltip>
    </span>
  );
};
